import React from "react";
import { AccountInformation } from "./AccountInformation";
import { PersonalInformation } from "./PersonalInformations";
import { NotificationInformation } from "./NotificationInformation";
import { PaymentInformation } from "./PaymentInformation";
import ProfileImage from "./ProfileImage";
import { SSOInformation } from "./SSOInformation";
import { useTitle } from "../Layout/Mobility3/Main";

export const Settings: React.FC = () => {
   useTitle("Settings");  
  
   return (
      <>
         <AccountInformation />
         <ProfileImage />
         <PersonalInformation />
         <NotificationInformation />
         <SSOInformation />
         <PaymentInformation />
      </>
   );
}